module.exports = __webpack_public_path__ + "public/img/荣誉奖项AWARDS_CN.09ac77df.png";